import { ReactElement } from 'react';
import { debug } from 'zf-web-infra';
import { ColumnProps } from 'antd/es/table';
import { TextProps } from '../types';

export function Text<T>(props: TextProps<T>): ReactElement | null {
  debug.common('Text', props);
  return null;
}

Text.displayName = 'Text';

export function getTextProps<T>(child: ReactElement<ColumnProps<T>>): ColumnProps<T> {
  debug.common('getTextProps');

  return {
    ...child.props
  };
}
